import { Message } from 'element-ui'
export default function(file) {
  return new Promise((resolve, reject) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    const isLt2M = file.size / 1024 / 1024 < 2
    console.log(isJpgOrPng, 'isJpgOrPng')
    console.log(isLt2M, 'isLt2M')
    if (!isJpgOrPng) {
      reject(
        Message({
          message: '上传图片只能是JPG或PNG 格式',
          type: 'error'
        })
      )
    }
    if (!isLt2M) {
      reject(
        Message({
          message: '上传头像图片大小不能超过2MB!',
          type: 'error'
        })
      )
    }
    resolve()
  })
}
